/**
 * The canvas pointer tool — which gesture a plain left-drag performs.
 *
 * This is the first persistent tool mode on the canvas; everything else in
 * the palette is a stateless button that opens something. Deliberately kept
 * separate from `viewMode` (canvas vs simplified list), which is a different
 * axis entirely.
 *
 *   hand   — drag pans the viewport (the long-standing default)
 *   select — drag on empty canvas draws a marquee, selecting every node it
 *            touches
 *
 * Shift+drag remains a temporary marquee regardless of tool, so the existing
 * `canvas.boxSelect` gesture is unaffected by this mode.
 */

// Written as an explicit union rather than `typeof CANVAS_TOOLS[number]`:
// deriving it needs `as const`, and apps/console's forbidden-syntax guard
// (`npm run lint:types`) rejects every `as`.
export type CanvasTool = 'hand' | 'select'

/** Menu order. */
export const CANVAS_TOOLS: readonly CanvasTool[] = ['hand', 'select']

export const DEFAULT_CANVAS_TOOL: CanvasTool = 'hand'
